<span class="update-message">
  Uppdatering hittad! Tryck på knappen för att installera
</span>
<div matSnackBarActions>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="onUpdate()"
    class="update-button">
    Uppdatera
  </button>
  <button 
    mat-button
    matSnackBarAction
    class="close-button">
    Stäng
  </button>
</div>
